var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddedWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1291,
    cy: 16.9112,
    r: 16.1796,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7199 12.7123C15.3451 11.1101 13.0525 10.6791 11.3299 12.1463C9.60735 13.6134 9.36484 16.0664 10.7176 17.8016C11.8423 19.2442 15.246 22.287 16.3616 23.2718C16.4864 23.382 16.5488 23.4371 16.6216 23.4587C16.6851 23.4776 16.7547 23.4776 16.8182 23.4587C16.891 23.4371 16.9534 23.382 17.0782 23.2718C18.1938 22.287 21.5975 19.2442 22.7222 17.8016C24.075 16.0664 23.862 13.598 22.1099 12.1463C20.3577 10.6945 18.0947 11.1101 16.7199 12.7123Z",
    fill: "#FF1212",
    stroke: "#3C4242",
    strokeWidth: 1.26066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddedWishlist);
export default __webpack_public_path__ + "static/media/AddedWishlist.927d25b34b8cee6258055dce683c0a50.svg";
export { ForwardRef as ReactComponent };